import React from 'react'
import ThirdPartyPagination from 'react-js-pagination'

import * as styles from './pagination.module.css'

export interface PaginationProps {
  totalItemsCount: number
  activePage?: number
  itemsCountPerPage?: number
  pageRangeDisplayed?: number
  prevPageText?: React.ReactChild
  nextPageText?: React.ReactChild
  lastPageText?: React.ReactChild
  firstPageText?: React.ReactChild
  disabledClass?: string
  hideDisabled?: boolean
  hideNavigation?: boolean
  innerClass?: string
  itemClass?: string
  itemClassFirst?: string
  itemClassPrev?: string
  itemClassNext?: string
  itemClassLast?: string
  linkClass?: string
  activeClass?: string
  activeLinkClass?: string
  linkClassFirst?: string
  linkClassPrev?: string
  linkClassNext?: string
  linkClassLast?: string
  hideFirstLastPages?: boolean

  onChange: (pageNumber: number) => void
  getPageUrl?: (pageNumber: number) => string
}

const pageTexts = {
  prevPageText: 'prev',
  nextPageText: 'next',
  lastPageText: 'last',
  firstPageText: 'first',
}

const classProps: Partial<PaginationProps> = {
  disabledClass: styles.disabled,
  innerClass: styles.inner,
  itemClass: styles.item,
  itemClassFirst: styles.itemFirst,
  itemClassPrev: styles.itemPrev,
  itemClassNext: styles.itemNext,
  itemClassLast: styles.itemLast,
  activeClass: styles.active,
  activeLinkClass: styles.activeLink,
  linkClass: styles.link,
  linkClassFirst: styles.linkFirst,
  linkClassPrev: `${styles.linkPrev} pagination__prev`,
  linkClassNext: `${styles.linkNext} pagination__next`,
  linkClassLast: styles.linkLast,
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const handleChange = (pageNumber: number) => {
    if (props.onChange) {
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0 })
      }

      return props.onChange(pageNumber)
    }
  }

  if (!props.totalItemsCount) {
    return null
  }

  return <ThirdPartyPagination {...props} {...classProps} {...pageTexts} onChange={handleChange} />
}

export default Pagination
